import React from 'react'
import { MaterialReactTable } from 'material-react-table'

/**
 * Tabla estándar del módulo. Look cohesivo: header suave, filas zebra, hover, bordes finos, sin sombra.
 * Buscador global siempre visible + filtros por columna. Centraliza el estilo de TODAS las tablas.
 */
const TablaPrecios = ({ columns, data, isLoading = false, pageSize = 15, columnPinning, onRowClick = null, ...rest }) => (
  <MaterialReactTable
    columns={columns}
    data={data}
    state={{ isLoading }}
    enableColumnActions={false}
    enableColumnFilters
    enableGlobalFilter
    enableDensityToggle={false}
    enableFullScreenToggle={false}
    enableHiding={false}
    enableColumnPinning
    enableStickyHeader
    positionGlobalFilter="left"
    muiSearchTextFieldProps={{
      placeholder: 'Buscar…',
      size: 'small',
      variant: 'outlined',
      sx: { minWidth: 240 },
    }}
    muiTablePaperProps={{
      elevation: 0,
      sx: { border: '1px solid #e3e7ec', borderRadius: '10px', overflow: 'hidden' },
    }}
    muiTopToolbarProps={{ sx: { backgroundColor: '#fff', minHeight: 48 } }}
    muiBottomToolbarProps={{ sx: { backgroundColor: '#fff' } }}
    muiTableContainerProps={{ sx: { maxHeight: 560 } }}
    muiTableHeadCellProps={{
      sx: {
        backgroundColor: '#f4f6f8',
        color: '#56606b',
        fontWeight: 700,
        fontSize: '10.5px',
        textTransform: 'uppercase',
        letterSpacing: '0.4px',
        borderBottom: '1px solid #e3e7ec',
        py: 1,
      },
    }}
    muiTableBodyCellProps={{
      sx: { fontSize: '12.5px', color: '#2b3440', borderBottom: '1px solid #eef1f4', py: 0.75 },
    }}
    muiTableBodyRowProps={({ row }) => ({
      // onRowClick (opcional): la fila entera abre el detalle.
      ...(onRowClick ? { onClick: () => onRowClick(row.original) } : {}),
      sx: {
        backgroundColor: row.index % 2 === 0 ? '#ffffff' : '#fafbfc',
        '&:hover td': { backgroundColor: '#eef4fb !important' },
        ...(onRowClick ? { cursor: 'pointer' } : {}),
      },
    })}
    initialState={{
      density: 'compact',
      showGlobalFilter: true,
      pagination: { pageSize, pageIndex: 0 },
      ...(columnPinning ? { columnPinning } : {}),
    }}
    {...rest}
  />
)

export default TablaPrecios
